<template>
    <PanelItem :index="index" :field="field">
        <template #value>
            <div
                v-if="field.value"
                class="ck-editor-detail prose dark:prose-invert max-w-none"
                v-html="decodedValue"
            />
            <p v-else>&mdash;</p>
        </template>
    </PanelItem>
</template>

<script>
export default {
    props: ['index', 'resource', 'resourceName', 'resourceId', 'field'],

    computed: {
        decodedValue() {
            const el = document.createElement('textarea')
            el.innerHTML = this.field.value
            return el.value
        },
    },
}
</script>

<style>
.ck-editor-detail > * + * {
    margin-top: 0.5rem;
}

.ck-editor-detail a {
    color: rgb(var(--colors-primary-500));
    text-decoration: underline;
}

.ck-editor-detail ul {
    list-style-type: disc;
    padding-left: 1.5rem;
}

.ck-editor-detail ol {
    list-style-type: decimal;
    padding-left: 1.5rem;
}

.ck-editor-detail blockquote {
    border-left: 4px solid rgb(var(--colors-slate-300));
    padding-left: 1rem;
    color: rgb(var(--colors-slate-500));
}

.dark .ck-editor-detail blockquote {
    border-left-color: rgb(var(--colors-slate-600));
}

.ck-editor-detail table {
    width: 100%;
    border-collapse: collapse;
}

.ck-editor-detail table td,
.ck-editor-detail table th {
    border: 1px solid rgb(var(--colors-slate-300));
    padding: 0.5rem;
}

.dark .ck-editor-detail table td,
.dark .ck-editor-detail table th {
    border-color: rgb(var(--colors-slate-600));
}
</style>
